import { InteractivityPoll } from 'modules/AnchorAPI/v3/episodes/fetchInteractivityPoll';

export function getChangedValues<T extends Record<string, any>>(
  initialValues: T,
  submittedValues: Partial<T>
): Record<string, any> {
  return Object.keys(submittedValues).reduce((updates, el) => {
    if (submittedValues[el] !== initialValues[el]) {
      return {
        ...updates,
        [el]: submittedValues[el],
      };
    }
    return updates;
  }, {});
}

export function validate(values: Partial<InteractivityPoll>) {
  type Object = Record<string, any>;
  const errors: Object = {};
  if (!values.question) {
    errors.question = 'Required';
  }
  const { options } = values;
  if (options && options.length) {
    const optionsArrayErrors: Object[] = [];
    options.forEach((option, index) => {
      const optionErrors: Record<string, any> = {};
      if (!option.description || !option.description?.trim()) {
        optionErrors.description = `Required`;
        optionsArrayErrors[index] = optionErrors;
      }
    });
    errors.options = optionsArrayErrors;
  }
  return errors;
}
